import React from "react"
import { withNewTradeContainer } from "../../../containers/default"
import CustomButton from "../../shared/CustomButton"
import KeyDropdownValue from "../../shared/KeyDropdownValue"
import InputKeyValue from "../../shared/InputKeyValue"
import { CloseMD } from "../../normalizer"

const CreateTrade = ({
  onUserChange,
  onSubmit,
  onContractChange,
  campaign,
  users,
  selectedUser,
  onClose,
}) => {
  const handleSubmit = e => {
    e.preventDefault()
    onSubmit()
  }

  return (
    <div className="create-trade-modal">
      <div className="create-trade-modal__header">
        <h4 className="create-trade-modal__title">Pedir troca de contrato</h4>
        {onClose && (
          <button
            type="button"
            className="create-trade-modal__close"
            onClick={onClose}
            aria-label="Fechar"
          >
            <CloseMD />
          </button>
        )}
      </div>
      <p className="create-trade-modal__description">
        Selecione o nome do utilizador e insira o número de contrato para fazer o pedido de troca.
      </p>
      <form onSubmit={handleSubmit} className="create-trade-modal__form">
        <KeyDropdownValue
          title="Nome do utilizador"
          isClearable
          campaign={campaign}
          onChange={onUserChange}
          options={users}
          getOptionLabel={option =>
            option.employee_identifier || option.email
          }
          selectedValue={selectedUser}
          getOptionValue={option => option.id}
          placeholder="Selecione"
          // classNamePrefix="custom-select"
          name="sale-trade-create-user-select"
        />
        <InputKeyValue
          title="Número do contrato"
          type="text"
          onChange={e => onContractChange(e.target.value)}
          placeholder="Inseria o número do contrato"
          name="sale-trade-create-contract"
        />
        <div className="create-trade-modal__actions">
          {onClose && (
            <CustomButton type="button" secondary onClick={onClose}>
              Cancelar
            </CustomButton>
          )}
          <CustomButton type="submit" terciary>
            Adicionar
          </CustomButton>
        </div>
      </form>
    </div>
  )
}

export default withNewTradeContainer(CreateTrade)
